import { styled, IconButton, DialogTitle, DialogContent } from '@mui/material';

const CustomTitle = styled(DialogTitle)({
    paddingRight: '2rem',
    color: 'var(--text-primary)',
    fontWeight: '400',
    fontStyle: 'normal',

    lineHeight: '160%',
    letterSpacing: '0.15px',
    '& .MuiTypography-root': {
        fontSize: '20px',
        color: 'var(--text-primary)',
        fontWeight: '400',
    },
});

const CloseIconButton = styled(IconButton)({
    zIndex: 2,
    position: 'absolute',
    right: '0.5rem',
    color: '#5C5D6A',
});

const CustomBody = styled(DialogContent)(({ sx }) => ({
    flexDirection: 'column',
    maxWidth: '80rem',
    maxHeight: '80vh',
    overflowY: 'auto',
    ...sx,
}));

export { CustomTitle, CloseIconButton, CustomBody };
